import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import './styles/atoms/menu-button.css';
import './styles/atoms/link-picker.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA } from './utils/analytics';

initGA();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);


reportWebVitals();

export { default as SignIn } from './pages/(logging)/sign-in';
export { default as SignUp } from './pages/(logging)/sign-up';
export { default as Restore } from './pages/(logging)/restore';

export { default as Welcome } from './pages/(logged-in)/welcome';
export { default as ResumeBuilder } from './pages/(logged-in)/resume-builder';
export { default as ResumeReview } from './pages/(logged-in)/resume-review';
export { default as AITools } from './pages/(logged-in)/ai-tools';
export { default as NewBaseResume } from './pages/(logged-in)/new-base-resume';
export { default as ResumeEditor } from './pages/(logged-in)/resume-editor';
export { default as Autofill } from './pages/(logged-in)/autofill';
export { default as Extension } from './pages/(logged-in)/extension';
export { default as Profile } from './pages/(logged-in)/profile';
export { default as CRM } from './pages/(logged-in)/crm';
export { default as Upgrade } from './pages/(logged-in)/upgrade';
export { default as Dashboard } from './pages/(logged-in)/dashboard';
export { default as Contacts } from './pages/(logged-in)/contacts';
export { default as Documents } from './pages/(logged-in)/documents';
export { default as Purchase } from './pages/(logged-in)/purchase';
export { default as PaymentSuccess } from './pages/(logged-in)/payment-success';
export { default as EmojisDebug } from './pages/(logged-in)/debug/emojis';

export { default as NotFound } from './pages/NotFound';
